import { Image } from './common';
export { Image };
import { ISalesChannel } from './SalesChannel';

export enum EnumStatus {
  Draft = 'Draft',
  Active = 'Active',
  Archived = 'Archived',
}
export enum EnumProductType {
  Simple = 'Simple',
  Variant = 'Variant',
  Set = 'Set',
  Service = 'Service',
  GiftCard = 'GiftCard',
}

export enum EnumServiceType {
  Text = 'Text',
  Radio = 'Radio',
  Checkbox = 'Checkbox',
  Selector = 'Selector',
}

export enum EnumProductProperty {
  Physical = 'Physical',
  Virtual = 'Virtual',
  None = 'None',
}

export interface SalesChannelQuantityItem extends ISalesChannel {
  availableQuantity: number;
  presaleQuantity: number;
}

export enum EDangerousType {
  Explosives = 'Explosives',
  Gases = 'Gases',
  FlammableLiquids = 'FlammableLiquids',
  OxidizingAndPeroxide = 'OxidizingAndPeroxide',
  Toxic = 'Toxic',
  Radioactive = 'Radioactive',
  Corrosive = 'Corrosive',
  Miscellaneous = 'Miscellaneous',
}

export interface ISalesChannelItems {
  availableQuantity: number;
  channelType: string;
  name: string;
  salesChannelUuid: string;
}

export interface IWarehouse {
  oversellingQuota: number;
  totalAvailableForSale: number;
  unassignedAvailableForSale: number;
  warehouseName: string;
  warehouseStock: number;
  warehouseUuid: string;
  salesChannelItems: ISalesChannelItems[];
}

export interface ProductItem {
  dangerousGoodsClasses: EDangerousType;
  sku: string;
  name: string;
  measurementUnit: MeasurementUnit;
  remarks: string;
  thumbnailImage: Image;
  thumbnailUrl?: string;
  productType: EnumProductType;
  stock: number;
  defaultSalePrice: number;
  defaultRrp: number;
  localPrices: Record<string, unknown>;
  defaultCurrency: string;
  tags: { name: string; uuid: string };
  status: EnumStatus;
  brand: IBrand;
  barcode: string;
  description: string;
  codes: ProductCode[];
  inventoryQuota: number;
  stockAvailable?: number;
  quotaEnabled: boolean;
  simpleProductPriceSettings: ProductPriceSetting[];
  dimensions: ProductDimensions;
  customsInformation: CustomsInformation;
  productStorage: ProductStorage;
  storeUuid: string;
  uuid?: string;
  productSet: { items: IProductSet[] };
  productVariant: IProductVariant;
  taxRule?;
  cost?: number;
  stockQuantity?: number;
  productSetPriceSettings: IProductSetPriceSettings<IProductSetPriceSettingsItems>[];
  dataValid?: boolean;
  inventoryUuid: string;
  salesChannelQuotas: SalesChannelQuantityItem[]; //等salesChannelVO
  priceTiers: IPriceTier[];
  warehouseStocks?: IWarehouse[];
}

export interface IPriceTier {
  currencyCode: string;
  deletable: boolean;
  remarks: string;
  title: string;
  uuid: string;
}
export interface IProductSetPriceSettings<T> {
  title: string;
  setPrice: number;
  currency: string;
  notes: string;
  priceTierUuid?: string;
  items: T[];
  deletable?: boolean;
}
export interface IProductSetPriceSettingsItems {
  unitPrice: number | string;
  productUuid: string;
  productName: string;
  noOfUnit: number;
}
export interface IProductSet {
  product: ProductItem;
  noOfUnit: number;
  unitPrice: number | string;
}

export interface MeasurementUnit {
  uuid: string;
  name: string;
}

export interface IBrand {
  uuid: string;
  name: string;
}
export interface ProductCode {
  title: string;
  code: string;
}
export interface ProductPriceSetting {
  title: string;
  price: number;
  rrp: number;
  currency: string;
  notes: string;
  priceTierUuid?: string;
}
export interface ProductDimensions {
  weight: number;
  weightUnit: string;
  measurementUnit: string;
  length: number;
  width: number;
  volume: number;
}
export interface CustomerItem {
  title: string;
  quantity: number;
  unitPrice: number;
  regionOfOrigin: string;
  hsCode: string;
}
export interface CustomsInformation {
  items: CustomerItem[];
}
export interface ProductStorage {
  locations: StorageLocation[];
}
export interface StorageLocation {
  aisle: string;
}
export interface IOption {
  id: string;
  label: string;
  values: string[];
}
export interface IVariant<T, P> {
  product: P;
  values: T[];
}
export interface IVariantValues {
  value: string;
  id: string;
}

export interface IProductVariant {
  options: IOption[];
  variants: IVariant<IVariantValues, ProductItem>[];
}
